import styles from './DevOpsServiceLink.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const linkList = [
  {
    title: 'GitLab',
    link: '/services/gitlab/',
    imgSrc: '/img/common/icon_gitlab.svg',
  },
  {
    title: 'GitHub Actions',
    link: '/services/githubactions/',
    imgSrc: '/img/common/icon_github_actions.svg',
  },
  {
    title: 'CircleCI',
    link: '/services/circleci/',
    imgSrc: '/img/common/icon_circleci.svg',
  },
]

const DevOpsServiceLink: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.DevOpsLink} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>DevOps & CI/CD運用支援</h2>
      <p className={styles.sectionRead}>モダンなツールを活用した、開発効率を上げるための運用支援ページもご覧ください</p>
      <nav className={styles.AWSNav}>
        <ul className={styles.AWSNav__list}>
          {linkList.map((item, index) => (
            <li key={index} className={styles.AWSNav__list__item}>
              <a href={item.link} className={styles.AWSNav__list__item__link}>
                <figure className={styles.AWSNav__list__item__link__figure}>
                  <img
                    src={item.imgSrc}
                    alt={item.title}
                    width={40}
                    height={40}
                    className={styles.AWSNav__list__item__link__figure__image}
                  />
                </figure>
                <span className={styles.AWSNav__list__item__link__text}>{item.title}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  )
}

export default DevOpsServiceLink
